{
  "name": "phoenix-frontend",
  "version": "2.6.0",
  "scripts": {
    "dev": "vite",
    "dev:remote": "vite --mode dev",
    "start": "vite",
    "build": "npm run build:development",
    "build:dev": "npm run build:development",
    "build:development": "vite build --mode dev",
    "build:prod": "npm run build:production",
    "build:staging": "vite build --mode staging",
    "build:production": "vite build --mode production",
    "preview": "vite preview",
    "test": "vitest",
    "test:run": "vitest run",
    "pdf:preview": "vitest run --config vitest.preview.config.ts",
    "format": "prettier --config .prettierrc.cjs --write 'src/**/*.{ts,tsx,json,less,md}' --log-level=warn",
    "lint": "eslint src",
    "audit": "npm audit --package-lock-only --omit=dev"
  },
  "dependencies": {
    "@ant-design/icons": "^6.2.5",
    "@react-pdf/renderer": "^4.5.1",
    "@reduxjs/toolkit": "^2.12.0",
    "antd": "^6.4.3",
    "axios": "^1.16.1",
    "buffer": "^6.0.3",
    "dayjs": "^1.11.21",
    "formik": "^2.4.9",
    "i18next": "^26.3.0",
    "i18next-browser-languagedetector": "^8.2.1",
    "i18next-http-backend": "^4.0.0",
    "localforage": "^1.10.0",
    "qs": "^6.10.1",
    "react": "^19.2.0",
    "react-dom": "^19.2.0",
    "react-i18next": "^17.0.8",
    "react-international-phone": "^4.8.0",
    "react-redux": "^9.3.0",
    "react-router-dom": "^7.16.0",
    "yup": "^1.7.1"
  },
  "devDependencies": {
    "@babel/core": "^7.29.7",
    "@playwright/mcp": "^0.0.75",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@touch4it/eslint-config-sandokan": "^0.25.0",
    "@types/node": "^24.12.4",
    "@types/qs": "^6.15.1",
    "@types/react": "^19.2.15",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.2",
    "@vitest/coverage-v8": "^4.1.7",
    "eslint": "^9.39.4",
    "jsdom": "^29.1.1",
    "less": "^4.6.4",
    "prettier": "^3.8.3",
    "typescript": "~6.0.3",
    "vite": "^8.0.14",
    "vitest": "^4.1.7"
  }
}
